<!-- 合作伙伴展示 -->
<template>
	<div class="container">
		<div class="mainMap">
			<div class="map">
				<!-- <img src="../../../public/images/map.png" alt=""> -->
				<div class="circular circular1" @click="circular = 1"></div>
				<div class="circular circular2" @click="circular = 2"></div>
				<div class="circular circular3" @click="circular = 3"></div>
				<div class="circular circular4" @click="circular = 4"></div>
				<div class="circular circular5" @click="circular = 5"></div>
				<div class="circular circular6" @click="circular = 6"></div>
				<img v-show="circular == 1" class="line line1" src="../../../public/images/line.png" alt="" />
				<img v-show="circular == 2" class="line line2" src="../../../public/images/line.png" alt="" />
				<img v-show="circular == 3" class="line line3" src="../../../public/images/line.png" alt="" />
				<img v-show="circular == 4" class="line line4" src="../../../public/images/line.png" alt="" />
				<img v-show="circular == 5" class="line line5" src="../../../public/images/line.png" alt="" />
				<img v-show="circular == 6" class="line line6" src="../../../public/images/line.png" alt="" />
			</div>
			<div v-show="circular == 1" class="contentLeft1">青海颐倍康养老服务有限公司</div>
			<div v-show="circular == 2" class="contentLeft2">贵州颐倍康养老服务有限公司</div>
			<div v-show="circular == 3" class="contentRight1">
				<span>颐倍康南京养老服务有限公司沈阳分公司</span>
				<span>辽宁福鞍康健康产业发展有限公司</span>
			</div>
			<div v-show="circular == 4" class="contentRight2">
				<span>颐倍康南京养老服务有限公司</span>
				<span>南京嘉美达电子科技发展有限公司</span>
			</div>
			<div v-show="circular == 5" class="contentRight3">绍兴市颐倍康养老服务有限公司</div>
			<div v-show="circular == 6" class="contentRight4">颐倍康南京养老服务有限公司景德镇分公司</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				circular:0
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped="scoped">
.container {
	background: #fff;
	padding: 0 16% 0 16%;
	/* margin-top:40px; */
	overflow: hidden;
}

.container .mainMap {
	height: 480px;
	position: relative;
}
.container .mainMap .map {
	margin-top: 40px;
	width: 520px;
	height: 400px;
	position: absolute;
	left: 50%;
	/* top:50%; */
	transform: translateX(-50%);
}
.container .mainMap .map {
	background: url('../../../public/images/map.png') no-repeat;
	background-position: 100% 100%;
	background-size: 100% 100%;
	position: relative;
}
/* 圆圈 */
.container .mainMap .map .circular {
	position: absolute;
	width: 14px;
	height: 14px;
	background-color: #fc6619;
	border-radius: 100%;
	cursor: pointer;
}
.container .mainMap .map .circular::before {
	opacity: 0.75;
	animation: ripple 3s ease-out 0.5s infinite;
}
@keyframes ripple {
	0% {
		transform: scale(1);
	}
	to {
		opacity: 0;
		transform: scale(5);
	}
}
.container .mainMap .map .circular::after {
	opacity: 0.75;
	animation: ripple 3s ease-out 2s infinite;
}
.circular::before,
.circular::after {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border-radius: 100%;
	background-color: inherit;
}
.container .mainMap .map .circular1 {
	left: 32%;
	top: 54%;
}
.container .mainMap .map .circular2 {
	left: 50%;
	bottom: 20%;
}
.container .mainMap .map .circular3 {
	right: 23%;
	top: 38%;
}
.container .mainMap .map .circular4 {
	right: 28%;
	top: 61%;
}
.container .mainMap .map .circular5 {
	right: 27.8%;
	bottom: 25%;
}
.container .mainMap .map .circular6 {
	right: 34.4%;
	bottom: 21%;
}
/* 线 */
.line {
	position: absolute;
	height: 2px;
	background: #c1c1c1;
	opacity: 0.9;
	z-index: -1;
}
.line1 {
	left: -21%;
	top: 42.5%;
	width: 56%;
	transform: rotate(22deg);
}
.line2 {
	left: -18.5%;
	bottom: 24%;
	width: 70%;
	transform: rotate(4deg);
}
.line3 {
	right: -4.5%;
	top: 30%;
	width: 30%;
	transform: rotate(-28deg);
}
.line4 {
	right: -2.5%;
	top: 55%;
	width: 32%;
	transform: rotate(-20deg);
}
.line5 {
	right: -2.5%;
	bottom: 30%;
	width: 32%;
	transform: rotate(-9deg);
}
.line6 {
	right: -2.5%;
	bottom: 19%;
	width: 39%;
	transform: rotate(9deg);
}
.contentLeft1 {
	width: 20%;
	position: absolute;
	top: 20%;
	left: 0;
	font-size: 16px;
}
.contentLeft2 {
	width: 20%;
	/* height: 30px; */
	position: absolute;
	bottom: 38%;
	left: 0;
	font-size: 16px;
}
.contentRight1 {
	width: 26%;
	position: absolute;
	top: 12%;
	right: 0;
	font-size: 16px;
}
.contentRight1 span {
	display: block;
}
.contentRight1 span:first-of-type {
	margin-bottom: 4px;
}
.contentRight2 {
	width: 26%;
	position: absolute;
	top: 35%;
	right: 0;
	font-size: 16px;
}
.contentRight2 span {
	display: block;
}
.contentRight2 span:first-of-type {
	margin-bottom: 4px;
}
.contentRight3 {
	width: 26%;
	position: absolute;
	bottom: 43%;
	right: 0;
	font-size: 16px;
}
.contentRight4 {
	width: 26%;
	position: absolute;
	bottom: 27%;
	right: 0;
	font-size: 16px;
}
</style>
